import { Component, EventEmitter, HostListener, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom, Subscription } from 'rxjs';
import { PaymentService } from 'src/app/services/paymentService.service';
import { VendorService } from 'src/app/services/Vendor.service';
import Swal from 'sweetalert2';
import { ECreditCards, EPaymentModes, EPaymentTransactionType } from '../enum';
import { environment } from 'src/environments/environment';
declare var Stripe: any;

@Component({
  selector: 'app-stripe-payment',
  templateUrl: './stripe-payment.component.html',
  styleUrls: ['./stripe-payment.component.scss']
})

export class StripePaymentComponent implements OnInit {
  elements;
  @Input() module;
  @Input() stripeClientSecret;
  @Input() mandatoryFieldsList = [];
  @Input() PublishableKey;
  @Input() UnifiedAccountId;
  @Input() paymentMode = 0;
  @Input() CCAmount;
  @Input() VendorId;
  @Input() keyedInTransaction;
  @Input() TransactionType;
  @Input() enableAddressAutofill: boolean;
  @Input() voidPayment;
  @Input() VerifoneId;
  @Input() RefundAmount;
  @Input() ForceCreditReturn;
  @Output() emitStripeModalClose: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitConfirmaTokenResponse: EventEmitter<any> = new EventEmitter<any>();
  @Output() loaderStatus: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() ClosePaymentPage = new EventEmitter<any>();
  @Output() PaymentResponse = new EventEmitter<any>();
  @Input() newVendor;
  @Input() newVendorInfo;
  @Input() isPaymentWithAutoPay;
  @Input() MarketId: number;
  @Input() paymentGateway: number;
  showLoaderMesage = false;
  paymentModeText = '';
  paymentFailReason;
  isSaveInCCTResponse;
  tempCNPPayId = null;
  tempCNPAmount = null;
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };

  customerInfo = {
    FirstName: '',
    MiddleName: '',
    LastName: '',
    CompanyName: '',
    AddressOne: '',
    City: '',
    CountryCode: '',
    StateCode: '',
    StateId: 0,
    PostalCode: '',
    CountryId: 0,
    CellPhoneNumber: '',
    Email: '',
    FullName: '',
    VendorIdd: 0
  }
  mandateId = '';
  payStatus: string;
  paymentSuccessFul: boolean;
  paymentTable = [];
  paymentCount;
  paymentStarted = false;
  paymentInProgress = false;
  paymentProcessing = false;
  currentPayId;
  defaultmode: number;
  submitButtonName: string = '';
  isDisableSubmit: boolean = false;
  loaderIcon: Promise<boolean>;
  requestgatewaydetails;
  selectedDeviceId = 0;
  verifoneRecordId = 0;
  vendorInfo;
  credentials;
  tillNowPaid = 0;
  MASKEDCARDNUMBER = '';
  initiatedVoidCC = false;
  stripeTerminalDeviceId: any;
  isStripeTerminalPay = false;
  stripeResponse: any;
  private stripeResponseSubscription: Subscription;
  autopayLinledUnitList = [];
  AutoPopulateBillingInfoMsg: string = 'Auto Populate Customer Information';

  paymentCountdown: string = '0';
  CountdownS: number = 0;
  CurrencyCCAmount: string = "";
  constructor(private paymentService: PaymentService, private vendorService: VendorService,
    private renderer: Renderer2,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.paymentCount = 0;
    this.paymentTable = [];
    this.paymentCount++;
    const obj = {
      payId: this.paymentCount,
      payName: 'Payment ' + this.paymentCount,
      payAmount: this.CCAmount,
      payComplete: false,
      payNowDisable: true,
      payModeId: 0,
      orderId: null,
      changeAmount: 0,
      checkNum: 0,
      checkDate: '',
      bankName: '',
      ManualCardNumber: '',
      ManualCardExp: '',
      ManualCardName: '',
      CreditCardType: 0,
      ManualCardAuthorization: '',
      defaultmode: 0,
      uniqueTransId: null,
      payFailed: false,
      routingNumber: 0,
      accountNumber: 0,
      achManualCardAuthorization: '',
      accountType: 279,
      nameonAccount: '',
      isOpenEdgePaymentCompleted: false,
      remotePayIsSMS: false,
      remotePayPhoneNumber: '',
      remotePayIsEmail: false,
      remotePayEmailId: '',
      stripePaymentIntentId: 0,
      EnableAutopayOrCardOnFile: 'cancel',
      TerminalDeviceId: ''
    };
    this.paymentTable.push(obj);

    this.getVendorInfo();
    this.getCredentials();

    if (this.paymentMode == EPaymentModes.ACH) {
      this.paymentModeText = 'ACH Payment';
    } else if (this.paymentMode == EPaymentModes.DirectDebitEFT) {
      this.paymentModeText = 'EFT Payment';
    } else if (this.keyedInTransaction) {
      this.paymentModeText = 'Hosted Page Payment';
    } else if (!this.keyedInTransaction) {
      this.paymentModeText = 'Device Payment';
    }
    this.submitButtonName = this.module == 2 && !this.isPaymentWithAutoPay ? 'Set Autopay' : 'Make Payment';
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: BeforeUnloadEvent) {
    const payment = this.paymentTable?.find(o => o.payId === this.currentPayId);
    if (payment && !payment.isOpenEdgePaymentCompleted) {
      const obj = {
        MarketId: this.MarketId ?? null,
        PaymentIntentId: payment.stripePaymentIntentId ?? '',
        DeviceId: payment.TerminalDeviceId ?? '',
        OrderId: payment.orderId ?? 0,
        VerifoneId: this.verifoneRecordId ?? 0,
        VendorId: this.customerInfo?.VendorIdd ?? 0,
        keyedInTransaction: this.keyedInTransaction ?? false
      };
      localStorage.setItem('StripeCancelPaymentReq', JSON.stringify(obj));
    }
  }

  async getVendorInfo() {
    this.AutoPopulateBillingInfoMsg = "Auto Populate Vendor Information";
    if (this.newVendor && this.newVendorInfo) {
      this.customerInfo.FirstName = this.newVendorInfo.FirstName;
      this.customerInfo.MiddleName = this.newVendorInfo.MiddleName;
      this.customerInfo.LastName = this.newVendorInfo.LastName;
      this.customerInfo.CompanyName = this.newVendorInfo.CompanyName;
      this.customerInfo.AddressOne = this.newVendorInfo.Address;
      this.customerInfo.City = this.newVendorInfo.City;
      this.customerInfo.CountryCode = this.newVendorInfo.Country;
      this.customerInfo.StateCode = this.newVendorInfo.DLState;
      this.customerInfo.StateId = this.newVendorInfo.State;
      this.customerInfo.PostalCode = this.newVendorInfo.ZipCode;
      this.customerInfo.CountryId = this.newVendorInfo.CountryCode;
      this.customerInfo.CellPhoneNumber = this.newVendorInfo?.CellPhone;
      this.customerInfo.Email = this.newVendorInfo.Email;
      this.customerInfo.FullName = this.newVendorInfo?.VendorName;
      this.customerInfo.VendorIdd = this.newVendorInfo?.VendorId;
      this.MarketId = this.newVendorInfo.MarketId;
    } else {
      const res = await lastValueFrom(
        this.vendorService.GetVendorById(this.VendorId, this.MarketId)
      );
      if (res !== null) {       
        this.vendorInfo = res.body;
        this.customerInfo.FirstName = this.vendorInfo.FirstName;
        this.customerInfo.MiddleName = this.vendorInfo.MiddleName;
        this.customerInfo.LastName = this.vendorInfo.LastName;
        this.customerInfo.CompanyName = this.vendorInfo.CompanyName;
        this.customerInfo.AddressOne = this.vendorInfo.Address;
        this.customerInfo.City = this.vendorInfo.City;
        this.customerInfo.CountryCode = this.vendorInfo.Country;
        this.customerInfo.StateCode = this.vendorInfo.DLState;
        this.customerInfo.StateId = this.vendorInfo.State;
        this.customerInfo.PostalCode = this.vendorInfo.ZipCode;
        this.customerInfo.CountryId = this.vendorInfo.CountryCode;
        this.customerInfo.CellPhoneNumber = this.vendorInfo.CellPhone;
        this.customerInfo.Email = this.vendorInfo.Email;
        this.customerInfo.FullName = this.vendorInfo.VendorName;
        this.customerInfo.VendorIdd = this.vendorInfo.VendorId;
        this.MarketId = this.vendorInfo.MarketId;
      }
    }
  }

  getCredentials() {
    this.paymentService.getCCCredentials(this.MarketId).subscribe((res) => {
      if (res !== null) {
        this.paymentGateway = res.PaymentGateWay;
        this.credentials = res.GatewayDetails ? JSON.parse(res.GatewayDetails) : null;
        if (this.voidPayment == true) {
          this.voidPaymentTransaction(this.VerifoneId, this.credentials);
        }
        else {
          this.initiatePaymentRequest();
        }
      }
    })
  }

  async initiatePaymentRequest() {
    this.paymentStarted = true;
    const amount = this.CCAmount;
    const payId = 1;
    this.currentPayId = payId;
    this.stripeClientSecret = this.credentials.SecretKey;
    this.PublishableKey = this.credentials.PublishableKey;
    this.UnifiedAccountId = this.credentials.AccountID;

    if (this.keyedInTransaction) {
      this.saveInVerifoneUnsaved(amount, payId);
    }
  }

  saveInVerifoneUnsaved(amount, payId) {
    this.paymentFailReason = '';
    let CCTModel = this.generateIntialCCT(this.CCAmount, 1, 1, 1, null, null, null, null);
    this.paymentService.saveVerifoneUnSaved(CCTModel).subscribe((cctRes) => {
      if (cctRes.Success) {
        let cctId = cctRes.Id;
        this.verifoneRecordId = cctRes.Id;
        this.paymentTable.find(o => o.payId == payId).orderId = cctRes.OrderId;
        this.paymentTable.find(o => o.payId == payId).uniqueTransId = cctRes.Id;
        this.isSaveInCCTResponse = true;
        if (this.keyedInTransaction) {
          this.isPaymentWithAutoPay = false;
          this.defaultmode = 5; //Stripe Hosted Page
          this.paymentTable.find(o => o.payId == payId).payModeId = this.defaultmode;
          this.paymentTable.find(o => o.payId == payId).defaultmode = this.defaultmode;
          this.paymentMode = this.defaultmode; //Stripe Hosted Page
          this.tempCNPAmount = amount;
          this.tempCNPPayId = payId;
          this.stripeScript();
        }
      } else {
        this.loaderIcon = Promise.resolve(false);
        this.paymentStarted = false;
        this.toastr.error("We couldn't create CCT, Please try again!", 'Failure', this.toasterConfig);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
      this.paymentStarted = false;
      this.toastr.error(' Something went wrong!', 'Failure', this.toasterConfig);
    });
  }

  generateIntialCCT(amt, transTypeId, ptId, paymentModeId, payvoid, cardNumber, authCode, voidOrderId) {
    let CreditCardNumber = cardNumber ? cardNumber.substr(cardNumber.length - 4) : "";
    const CCTModel = {
      verifoneRecordId: this.verifoneRecordId,
      Amount: amt,
      VendorId: this.VendorId,
      CreditCardNumber: CreditCardNumber,
      CreditCardType: ECreditCards.Visa,
      ResponseCode: "",
      ResponseMessage: "",
      OrderId: voidOrderId ? voidOrderId : "",
      TransactionDateTime: new Date(),
      ProcessStatus: "In progress"
    };
    return Object.assign(CCTModel);
  }

  addJsToElement(src: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    this.renderer.appendChild(document.body, script);
    return script;
  }

  async stripeScript(): Promise<void> {
    this.getPaymentIntent();
    if (this.isEftPayment()) {
      setTimeout(() => {
        if (this.customerInfo?.Email) {
          this.loaderStatus.emit(true);
          this.onStripePay();
        }
      }, 2000);
    }
  }

  getPaymentIntent() {
    const payMode = this.paymentTable.find(o => o.payId === this.currentPayId).payModeId;
    let InputObj = {
      OrderId: this.paymentTable.find(o => o.payId === this.currentPayId).orderId,
      UserId: 0,
      VendorId: this.customerInfo.VendorIdd,
      TransactionType: this.paymentMode,//this.getLovTransactionType(),
      Amount: Math.round(parseFloat(this.CCAmount) * 100) ,
      MarketId: this.MarketId,
      SelectedPaymentModeType: payMode == EPaymentModes.DirectDebitEFT ? 'EFT' : payMode == EPaymentModes.ACH ? 'ACH' : 'HostedPage',
      cctId: this.paymentTable.find(o => o.payId === this.currentPayId).uniqueTransId,
      SetUpFutureUsage: this.paymentTable.find(o => o.payId === this.currentPayId).EnableAutopayOrCardOnFile == 'cancel' ? null : 'off_session',
      Name: this.customerInfo.FullName,
      Email: this.customerInfo.Email,
      Phone: this.customerInfo.CellPhoneNumber,
      Customer: "", //this.processPayment?.CustomerId ? this.processPayment.CustomerId: this.facOpsDataService?.saveautopay?.CustomerId || '',
      PaymentTransactionType: 2//this.getTransactionType()
    }

    this.paymentService.getPaymentIntent_Stripe(this.MarketId, InputObj).subscribe((response: any) => {
      if (response) {
        this.paymentTable.find(o => o.payId === this.currentPayId).stripePaymentIntentId = response.PaymentIntentId
        this.stripeClientSecret = response.ClientSecret;

        var stripe = Stripe(this.PublishableKey, { stripeAccount: this.UnifiedAccountId });
        var elements = this.createStripeElements(stripe);
        this.elements = elements;

        this.mountExpressCheckoutElement(elements);
        this.mountPaymentElement(elements);
        if (this.paymentMode == EPaymentModes.HostedPage) {
          this.mountAddressElements(elements);
        }

        const paymentElement = elements.getElement('payment');
        paymentElement.on('change', (event) => {
          this.handlePaymentMethodChange(event, elements);
        });

        const form = document.querySelector("#payment-form");
        form.addEventListener('submit', (event) => this.submitPaymentForm(event, elements, stripe));
      }
    }, err => {
      const errprResponse = this.handelStripeError(err);
      errprResponse.Reason = errprResponse.Reason + " [Errror in Creating PaymentIntent]";
      errprResponse['errprResponse'] = JSON.stringify(err);
      this.saveStripeCCTransactionFail(errprResponse, "", InputObj.OrderId, EPaymentTransactionType.Declined);
      this.loaderIcon = Promise.resolve(false);
    });
  }

  createStripeElements(stripe) {
    const elementOptions = {
      clientSecret: this.stripeClientSecret,
      appearance: {
        theme: 'stripe'
      }
    };
    return stripe.elements(elementOptions);
  }

  mountPaymentElement(elements: any): void {
    const paymentElementOptions = {
      layout: 'tabs',
    };

    var paymentElement = elements.create('payment', {

      defaultValues: {
        billingDetails: {
          name: this.customerInfo ? (this.customerInfo.FirstName + this.customerInfo.MiddleName + this.customerInfo.LastName) : '',
          email: this.customerInfo?.Email ?? '',
        }
      }
    });
    paymentElement.mount('#payment-element');
  }

  mountExpressCheckoutElement(elements: any): void {
    const expressCheckoutContainer = document.getElementById('express-checkout-element');
    if (!expressCheckoutContainer) {
      return;
    }

    try {
      const expressCheckoutElement = elements.create('expressCheckout', {
        paymentMethods: {
          applePay: 'auto',
          googlePay: 'auto',
          amazonPay: 'auto'
        }
      });
      expressCheckoutElement.mount('#express-checkout-element');
    } catch {
      // Keep payment flow working on Stripe versions/accounts without express checkout enabled.
      expressCheckoutContainer.style.display = 'none';
    }
  }

  mountAddressElements(elements) {
    const isAddressMandatory = this.credentials?.MandatoryAddressField ? true : false;
    let addressElementOptions = {
      mode: 'billing',
      autocomplete: {
        mode: this.enableAddressAutofill ? 'automatic' : 'disabled'
      },
      fields: {
        name: 'always',
        address: isAddressMandatory ? 'always' : 'never',
        phone: 'always',
        email: 'always'
      },
      validation: {
        "name": {
          "required": "always"
        },
        ...(isAddressMandatory && {
          "address": {
            "line1": {
              "required": "always"
            },
            "line2": {
              "required": "never"
            },
            "city": {
              "required": "always"
            },
            "state": {
              "required": "always"
            },
            "postal_code": {
              "required": "always"
            },
            "country": {
              "required": "always"
            }
          }
        }),
        "phone": {
          "required": "never"
        },
        "email": {
          "required": "never"
        }
      }
    };
    setTimeout(() => {
      const addressElement = elements.create('address', addressElementOptions);
      addressElement.mount('#address-element');
    }, 500)
  }

  getMandatoryFieldValue(field) {

    if (!this.credentials.MandatoryFieldSettings.length) {
      return 'never';
    }
    else {
      if (this.credentials.MandatoryFieldSettings[field] == true) {
        return 'always'
      }
    }
    return 'never';
  }

  closeStripeForm() {
    this.emitStripeModalClose.emit(true);
    this.loaderIcon = Promise.resolve(false);
    this.isDisableSubmit = false;
  }

  onStripePay() {
    const submitButton = document.getElementById("submit") as HTMLButtonElement;
    if (submitButton) {
      this.loaderIcon = Promise.resolve(true);
      this.isDisableSubmit = true;
      submitButton.click();
      this.loaderStatus.emit(false);
    }
  }

  async submitPaymentForm(event: Event, elements: any, stripe: any) {
    event.preventDefault();
    const { error: submitError } = await elements.submit();
    if (submitError) {
      this.loaderIcon = Promise.resolve(false);
      this.isDisableSubmit = false;
      this.handleError(submitError);
      return;
    }
    let returnTokenOrPaymentMethod = '';
    let errorData;
    if (this.module == 2) {
      const { setupIntent, error } = await stripe.confirmSetup({
        elements,
        params: {
          payment_method_data: {
            billing_details: {
              name: this.customerInfo.FirstName + this.customerInfo.MiddleName + this.customerInfo.LastName,
              email: this.customerInfo.Email,
            },
          },
        },
        redirect: 'if_required'
      });

      returnTokenOrPaymentMethod = setupIntent;
      errorData = error;
    } else {
      const { error, confirmationToken } = await stripe.createConfirmationToken({
        elements
      });
      returnTokenOrPaymentMethod = confirmationToken;
      errorData = error;
    }
    if (errorData) {
      this.handleError(errorData);
      return;
    }
    this.handlestripeToken(returnTokenOrPaymentMethod);
  }

  handleError(error) {
    this.toastr.warning('Failed to receive confirmation token', 'Payment Error', this.toasterConfig);
  }

  handlestripeToken(confirmationToken) {
    //this.PaymentResponse.emit(confirmationToken);
    this.getConfirmationTokenData(confirmationToken);
  }

  handlePaymentMethodChange(event: any, elements) {
    if (event.value) {
      const addressElementContainer = document.getElementById('address-element');
      const addressElement = elements.getElement('address');

      if (event.value.type === 'card') {
        if (addressElementContainer && !addressElementContainer.hasChildNodes()) {
          addressElement.mount('#address-element');
        }
      } else if (addressElement) {
        addressElement.unmount();
      }
    }
  }

  onClickAutoPopulateBillingInfo(checked) {
    let addressElement = this.elements.getElement('address');
    if (checked) {
      if (this.customerInfo) {
        if (addressElement) {
          addressElement.unmount();
          addressElement.destroy(); // Destroy the previous element
        }
        setTimeout(() => {
          const addressElementOptions = this.getAddressElementOptions(false);
          addressElement = this.elements.create('address', addressElementOptions);
          addressElement.mount('#address-element');
        }, 500);
      }
    } else {
      if (addressElement) {
        addressElement.unmount();
        addressElement.destroy();

        setTimeout(() => {
          const addressElementOptions = this.getAddressElementOptions(true);
          addressElement = this.elements.create('address', addressElementOptions);
          addressElement.mount('#address-element');
        }, 500);
      }
    }
  }

  isEftPayment(): boolean {
    return this.paymentMode == EPaymentModes.DirectDebitEFT || this.paymentMode == EPaymentModes.DirectDebitEFTOnFile;
  }

  isAchOrEftPayment(): boolean {
    return this.paymentMode == EPaymentModes.DirectDebitEFT || this.paymentMode == EPaymentModes.ACH || this.paymentMode == EPaymentModes.ACHOnFile || this.paymentMode == EPaymentModes.DirectDebitEFTOnFile;
  }

  isMandatoryAddressField(): boolean {
    return this.credentials?.MandatoryAddressField ? true : false;
  }

  getAddressElementOptions(isClear) {
    if (isClear) {
      return {
        mode: 'billing',
        fields: {
          name: 'always',
          address: 'always',
          phone: 'always',
          email: 'always'
        },
        defaultValues: {
          name: '',
          address: {
            line1: '',
            line2: '',
            city: '',
            state: '',
            postal_code: '',
            country: '',
          }
        }
      };
    } else {
      return {
        mode: 'billing',
        fields: {
          name: 'always',
          address: 'always',
          phone: 'always',
          email: 'always'
        },
        defaultValues: {
          name: this.customerInfo.FirstName + ' ' + this.customerInfo.MiddleName + ' ' + this.customerInfo.LastName,
          address: {
            line1: this.customerInfo.AddressOne ? this.customerInfo.AddressOne : "",
            line2: '',
            city: this.customerInfo.City ? this.customerInfo.City : "",
            state: this.customerInfo.StateCode ? this.customerInfo.StateCode : "",
            postal_code: this.customerInfo.PostalCode ? this.customerInfo.PostalCode : "",
            country: this.customerInfo.CountryCode,
          },
        }
      };
    }
  }

  getConfirmationTokenData(confirmationTokenInfo) {
    this.paymentInProgress = true;
    this.ConfirmPaymentIntent(confirmationTokenInfo, null);
  }

  onhstPayBtn(val) {
    if (val == 'Cancel') {
      let IntentId = this.paymentTable.find(o => o.payId === this.currentPayId).stripePaymentIntentId;
      let orderId = this.paymentTable.find(o => o.payId === this.currentPayId).OrderId;
      this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
      this.paymentService.CancelPaymentIntent(IntentId, this.MarketId).subscribe((cancelOrRefundRes: any) => {
        let CCTModel;
        const tempCCModel = {
          VerifoneId: this.verifoneRecordId,
          Card: "Credit Card",
          ResponseCode: '',
          ResponseMessage: cancelOrRefundRes.Status ?? '',
          ReceiptResponse: JSON.stringify(cancelOrRefundRes),
          TransactionDateTime: new Date(),
          OrderId: orderId,
          VendorId: this.VendorId,
          ProcessStatus: "Failed",
          PaymentTransactionTypeId: IntentId
        };
        CCTModel = Object.assign(tempCCModel);
        this.paymentService.saveVerifoneUnSaved(CCTModel).subscribe((res: any) => {
        });
      });

      this.ClosePaymentPage.emit()
    }
  }

  ConfirmPaymentIntent(confirmationTokenInfo, paymentMethodId) {
    if (this.isPaymentWithAutoPay) {
      //this.loaderIcon = Promise.resolve(true);
      //let selectedPayment = this.paymentTable.find(o => o.payId === this.currentPayId);
      //if (selectedPayment.payModeId !== EPaymentModes.CreditCard && this.stripeModalRef) {
      //  this.stripeModalRef.hide();
      //}
      //let inputObj = {
      //  OrderId: selectedPayment.uniqueTransId,
      //  UserId: this.userSessionService.userSessionData.UserId,
      //  TenantId: this.processPayment.TenantId,
      //  TransactionType: this.getLovTransactionType(),
      //  Amount: parseFloat(this.amountToPay) * 100,
      //  MarketId: this.MarketId,
      //  LeaseNo: this.processPayment.LeaseNo,
      //  PaymentMethod: confirmationTokenInfo.payment_method,
      //  Customer: this.processPayment?.CustomerId ? this.processPayment.CustomerId : this.facOpsDataService?.saveautopay?.CustomerId || '',
      //  PaymentTransactionType: this.getTransactionType(),
      //};
      //let paymentTrnsId = this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
      //this.paymentService.processPaymentWithAutopay(inputObj).subscribe((response: any) => {
      //  this.paymentTable.find(o => o.payId === this.currentPayId).stripePaymentIntentId = response.PaymentIntentId;
      //  this.GetStripeResponse(response, this.currentPayId, this.paymentTable.find(o => o.payId === this.currentPayId).orderId, paymentTrnsId, selectedPayment.payModeId);
      //}, () => {
      //  this.GetStripeResponse(null, this.currentPayId, this.paymentTable.find(o => o.payId === this.currentPayId).orderId, paymentTrnsId, selectedPayment.payModeId);
      //});
    } else {
      let paymentIntentId = this.paymentTable.find(o => o.payId === this.currentPayId).stripePaymentIntentId;
      let orderId = this.paymentTable.find(o => o.payId === this.currentPayId).orderId;
      let confirmationId = confirmationTokenInfo ? confirmationTokenInfo.id : null
      this.paymentService.ConfirmPaymentIntent(this.MarketId, paymentIntentId, paymentMethodId, confirmationId).subscribe((response: any) => {
        if (response) {
          if (this.paymentTable.find(o => o.payId === this.currentPayId).payModeId != EPaymentModes.CreditCard) {
            //this.prePayStatus = 'Payment';
            this.GetChargesDetailsByIntentId();
          }
        }
      }, err => {
        if (err?.error?.error) {
          const errprResponse = this.handelStripeError(err);
          errprResponse.Reason = "keyedInTransactionailure";
          errprResponse['errprResponse'] = JSON.stringify(err);
          this.saveStripeCCTransactionFail(errprResponse, "", orderId, EPaymentTransactionType.Declined);
          this.toastr.error(err.error.error, 'FkeyedInTransactionailure', this.toasterConfig);
        } else {
          const errprResponse = this.handelStripeError(err);
          errprResponse.Reason = errprResponse.Reason + " Failed to Confirm Payment Intent (keyedInTransactionailure)";
          errprResponse['errprResponse'] = JSON.stringify(err);
          this.saveStripeCCTransactionFail(errprResponse, "", orderId, EPaymentTransactionType.Declined);
          this.toastr.error('Failed to Confirm Payment Intent', 'Failure', this.toasterConfig);
        }
      });
    }
  }

  GetChargesDetailsByIntentId() {
    let paymentIntentId = this.paymentTable.find(o => o.payId === this.currentPayId).stripePaymentIntentId;
    let orderId = this.paymentTable.find(o => o.payId == this.currentPayId).orderId;
    let paymentMode = this.paymentTable.find(o => o.payId == this.currentPayId).payModeId;
    let paymentTrnsId = 5;//this.paymentService.GetPaymentTransactionTypeId(this.processPayment.Type);
    const obj = {
      PaymentIntentId: paymentIntentId,
      MarketId: this.MarketId,
      PayId: this.currentPayId,
      OrderId: orderId,
      PaymentTrnsId: paymentTrnsId,
      PaymentModeId: paymentMode
    }
    this.callGetStripeCharge(obj);
  }

  async callGetStripeCharge(payDetails) {
    let stripePaymentTable = this.paymentTable.find(o => o.payId === payDetails.PayId);
    let readerId = stripePaymentTable.payModeId == EPaymentModes.CreditCard ? stripePaymentTable.TerminalDeviceId : "";
    this.paymentService.GetChargesDetailsByIntentId(payDetails.PaymentIntentId, payDetails.MarketId, readerId).subscribe(async (res: any) => {
      if (res) {
        this.mandateId = res.MandateId;
        if (!res.CreditHolderName && payDetails?.NameOnCard) {
          res['CreditHolderName'] = payDetails.NameOnCard;
        }
        if (payDetails.PaymentModeId !== EPaymentModes.CreditCard) {// && this.stripeModalRef) {
          //this.stripeModalRef.hide();
        }
        if (res.Success && stripePaymentTable.EnableAutopayOrCardOnFile != 'cancel') {
          if (payDetails.PaymentModeId == EPaymentModes.CreditCard) {
            //this.paymentAccountId = await this.callGetAutoPayMethod();
            //res['PaymentMethodId'] = this.paymentAccountId;
          }
          //if (this.autopayLinledUnitList.length > 0) {
          //  this.loaderIcon = Promise.resolve(false);
          //  this.stripeResponse = res;
          //  this.linkedAutopayModalRef = this.modalService.show(this.linkedAutopay, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
          //  return;
          //}
        }
        if (payDetails.PaymentModeId == EPaymentModes.CreditCard && res.ResponseCode == '-1' && res.Reason == 'Transaction Time Out!') {
          this.toastr.warning('Please ask Administrator to Reset the Terminal Device', 'Alert', this.toasterConfig);
        }

        this.GetStripeResponse(res, payDetails.PayId, payDetails.OrderId, payDetails.PaymentTrnsId, payDetails.PaymentModeId);
      }
    }, () => {
      if (payDetails.PaymentModeId !== EPaymentModes.CreditCard) {//&& this.stripeModalRef) {
        //this.stripeModalRef.hide();
      }
    });
  }

  async GetStripeResponse(stripeRes, payId, orderId, paymentTrnsId, paymentMode) {
    this.loaderIcon = Promise.resolve(false);
    this.paymentTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted = true;
    if (stripeRes.Success) {
      this.paymentSuccessFul = true;
      this.payStatus = 'Success';
      this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = false;
      this.paymentTable.find(o => o.payId == this.currentPayId)['processedCNPCC'] = stripeRes;

      if ([EPaymentModes.CreditCard, EPaymentModes.HostedPage, EPaymentModes.CardOnfile].includes(paymentMode)) {
        if (paymentMode == EPaymentModes.CreditCard && stripeRes.IsInteracPayment) {
          let requestgatewaydetailsObj = JSON.parse(this.requestgatewaydetails);
          requestgatewaydetailsObj['IsInteracPayment'] = stripeRes.IsInteracPayment;
          this.requestgatewaydetails = JSON.stringify(requestgatewaydetailsObj);
        }
        const stripeCCModel = {
          Amount: parseFloat(stripeRes.Amount) / 100,
          Autopay: false,
          PaymentModeId: paymentMode,
          AutoCcProcessingDay: 0,
          CreditCardNumber: `XXXXXXXXXXX${stripeRes.CreditCardNumber}`,
          CreditCardType: this.paymentService.openEdgeCardType(stripeRes.CardBrand),
          NameonCard: stripeRes.CreditHolderName,
          CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(stripeRes.ExpiryMonth, 10)),
          CreditCardExpiryYear: parseInt(stripeRes.ExpiryYear, 10),
          CreditCardBillingAddress: stripeRes?.BillingDetails?.Address ? ((stripeRes.BillingDetails.Address.Line1 ?? '') + ',' + (stripeRes.BillingDetails.Address.Line2 ?? '')).trim().slice(0, 50) : '',
          CreditCardBillingZip: stripeRes?.BillingDetails?.Address?.PostalCode ?? "",
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: stripeRes.ChargeId,
          Key: stripeRes.PaymentIntentId,
          ResponseCode: stripeRes.ResponseCode,
          Reason: stripeRes?.Reason ?? '',
          PaymentAccountid: paymentMode == EPaymentModes.CardOnfile && stripeRes.PaymentMethodId ? stripeRes.PaymentMethodId : "",
          CcInfoPurged: false,
          DebitCardPayment: stripeRes.CardType == 'debit',
          OfflinePayment: 0,
          PaymentTransactionTypeId: paymentTrnsId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Processed,
          OrderId: orderId,
          EmvReceiptText: stripeRes.ReceiptUrl,
          TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
          TenantId: this.customerInfo.VendorIdd ? this.customerInfo.VendorIdd : null,
          MarketId: this.MarketId,
          GatewayDetails: this.requestgatewaydetails,
          PaymentMethodId: stripeRes.PaymentMethodId,
          CustomerId: stripeRes?.CustomerId ?? '',
          GatewayId: this.paymentGateway
        };
        this.paymentTable.find(o => o.payId == this.currentPayId)['processedStripeCC'] = stripeCCModel;
        this.MASKEDCARDNUMBER = stripeCCModel.CreditCardNumber;

        //if ([EPaymentOrigin.Rental, EPaymentOrigin.Transfer, EPaymentOrigin.ReInstate, EPaymentOrigin.MakePayment].includes(this.processPayment.Type) && this.paymentTable.find(ele => ele.payId == payId && ele.EnableAutopayOrCardOnFile != 'cancel')) {
        //  this.setUpStripeAutopayModel(stripeCCModel, paymentMode, payId);
        //}
        let GatewayResponse = JSON.parse(stripeRes.GatewayResponse);
        let CCTModel;
        const receiptText = stripeRes.ReceiptUrl //jsonResp.RESULT.RECEIPTTEXT;
        const entryMethodMatch = receiptText.match(/Entry Method\s+([^\n]+)/);
        const tempCCModel = {
          VerifoneId: this.verifoneRecordId,
          Amount: stripeCCModel.Amount,
          CreditCardNumber: stripeCCModel.CreditCardNumber,
          ResponseCode: stripeCCModel.ResponseCode ? stripeCCModel.ResponseCode : '00',
          ResponseMessage: "Approval",
          Card: this.keyedInTransaction ? "Credit Card" : "",
          TransactionDateTime: new Date(),
          TransactionTypeId: this.TransactionType,
          OrderId: stripeCCModel.OrderId,
          VendorId: this.VendorId,
          ProcessStatus: "Completed",
          ApprovalCode: stripeRes.ChargeId,
          PaymentTransactionTypeId: stripeCCModel.Key,
          PaymentTransactionType: "Payment Purchase",
          CreditCardType: stripeRes.CardBrand,
          EntryLegend: this.keyedInTransaction ? "CNP" : GatewayResponse.read_method,
          EntryMethod: entryMethodMatch ? entryMethodMatch[1].trim() : '',
          ReceiptResponse: JSON.stringify(stripeRes)
        };


        CCTModel = Object.assign(tempCCModel);
        const res = await lastValueFrom(
          this.paymentService.saveVerifoneUnSaved(CCTModel)
        );
        if ([EPaymentModes.HostedPage, EPaymentModes.CreditCard].includes(paymentMode)) {
          if (res) {
            this.capturePaymentIntent(this.MarketId, stripeCCModel.Key, orderId);
          }
        }
        this.gotoPaymentSuccess(stripeCCModel.Amount);
      }
      //this.gotoPaymentSuccess(this.popUpPayment, (parseFloat(stripeRes.Amount) / 100).toFixed(2));
    } else {
      this.paymentSuccessFul = false;
      this.paymentProcessing = false;
      this.payStatus = 'Failed';
      this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
      stripeRes['PaymentModeId'] = paymentMode;
      let CCTModel;
      const tempCCModel = {
        VerifoneId: this.verifoneRecordId,
        CreditCardNumber: stripeRes.CreditCardNumber,
        CardType: stripeRes.CardType,
        ResponseCode: stripeRes.ResponseCode,
        ResponseMessage: stripeRes?.Reason ?? '',
        Card: this.keyedInTransaction ? "Credit Card" : "",
        TransactionDateTime: new Date(),
        OrderId: orderId,
        VendorId: this.VendorId,
        ProcessStatus: "Failed",
        PaymentTransactionTypeId: stripeRes.PaymentIntentId,
        CreditCardType: this.paymentService.openEdgeCardType(stripeRes.CardBrand)
      };
      this.paymentFailReason = stripeRes?.Reason ?? '';
      CCTModel = Object.assign(tempCCModel);
      this.paymentService.saveVerifoneUnSaved(CCTModel).subscribe((res: any) => {
      });
      this.MASKEDCARDNUMBER = stripeRes.CreditCardNumber;

      Swal.fire({
        title: $localize`Payment Failed!`,
        html: `<h5>Uh-oh! We Were Unable To Process Your Payment</h5>
                <p>Transaction Time Out!</p>`,
        icon: "error",
        confirmButtonText: $localize`Ok`,
      }).then(result => {
        if (result.value) {
          this.gotoPaymentSuccess(0);
        }
      });
    }
  }

  getExpiryMonthValue(expiryMonth) {
    let tempMonth = 263;
    if (expiryMonth) {
      if (expiryMonth > 0 && expiryMonth < 13) {
        expiryMonth = tempMonth + expiryMonth;
      } else if (expiryMonth > 263 && expiryMonth < 276) {
        expiryMonth = expiryMonth;
      } else {
        expiryMonth = 264;
      }
    } else {
      expiryMonth = 264;
    }
    return expiryMonth;
  }

  gotoPaymentSuccess(amount) {
    this.paymentStarted = true;
    this.tillNowPaid += parseFloat(amount);
    if (this.paymentSuccessFul) {
      this.paymentTable.find(o => o.payId === this.currentPayId).payComplete = true;
    }
    if (this.paymentSuccessFul) {
      var obj = {
        VerifoneId: this.verifoneRecordId,
        PaymentSuccess: this.paymentSuccessFul,
        OrderId: this.paymentTable.find(o => o.payId == this.currentPayId).orderId,
        CardNumber: this.MASKEDCARDNUMBER
      }
      this.PaymentResponse.emit(obj);
    }
    else {
      var objFailure = {
        VerifoneId: this.verifoneRecordId,
        PaymentSuccess: this.paymentSuccessFul,
        OrderId: this.paymentTable.find(o => o.payId == this.currentPayId).orderId
      }
      this.PaymentResponse.emit(objFailure);
    }
  }

  voidPaymentTransaction(verifoneRecordId, credentials) {
    this.loaderIcon = Promise.resolve(true);
    const payId = 1;
    this.currentPayId = payId;
    this.paymentService.GetVerifoneUnSavedDate(verifoneRecordId).subscribe((res: any) => {
      let CCTModel = this.generateIntialCCT(this.CCAmount, 1, 1, 1, null, null, null, res.OrderId);
      this.paymentService.saveVerifoneUnSaved(CCTModel).subscribe((cctRes) => {
        if (cctRes.Success) {
          this.verifoneRecordId = cctRes.Id;
          const paymentAmount = this.RefundAmount > 0 ? this.RefundAmount : res.Amount;
          const orderId = res.OrderId;
          const DebitOrderId = cctRes.OrderId;
          const OpenEdgeTransType = res.TransactionTypeId;
          if (credentials) {
            let TransactionCardType = res.Card;
            var paymentTransactionTypeId = res.PaymentTransactionTypeId;
            var paymentReturnType = "CREDITVOID";
            if (this.RefundAmount > 0 || this.ForceCreditReturn == true) {
              paymentReturnType = "CREDITRETURN";
            }
            //if (TransactionCardType == 'Credit Card') {
              this.paymentService.GetChargesDetailsByIntentId(paymentTransactionTypeId, this.MarketId, "").subscribe(async (CharDetailres: any) => {
                if (CharDetailres) {
                  let Amt = Math.round(paymentAmount * 100);
                  const refundPaymentModel = {
                    PaymentIntentId: CharDetailres.PaymentIntentId,
                    ChargeId: CharDetailres.ChargeId,
                    Amount: Amt,
                    MarketId: this.MarketId,
                    OrderId: orderId,
                    GatewayDetails: null
                  }
                  this.paymentService.refundPaymentIntent(this.MarketId, refundPaymentModel).subscribe((cancelOrRefundRes: any) => {
                    if (cancelOrRefundRes) {
                      const tempCCModel = {
                        VerifoneId: this.verifoneRecordId,
                        Amount: this.RefundAmount > 0 ? this.RefundAmount : parseFloat(CharDetailres.Amount) / 100,
                        VendorId: this.VendorId,
                        ProcessStatus: "Completed",
                        CreditCardNumber: `XXXXXXXXXXX${CharDetailres.CreditCardNumber}`,
                        ResponseCode: cancelOrRefundRes.ResponseCode ? cancelOrRefundRes.ResponseCode : "00",
                        ResponseMessage: cancelOrRefundRes.Reason,
                        OrderId: orderId,
                        TransactionDateTime: new Date(),
                        TransactionTypeId: OpenEdgeTransType != '' ? OpenEdgeTransType : 'credit',
                        ReceiptResponse: JSON.stringify(cancelOrRefundRes),
                        Card: TransactionCardType,
                        CreditCardType: CharDetailres.CardBrand,
                        PaymentTransactionTypeId: cancelOrRefundRes.RefundIntentId,
                        ApprovalCode: cancelOrRefundRes.ChargeId,
                        PaymentTransactionType: paymentReturnType
                      };
                      const CCTModel = Object.assign(tempCCModel);
                      this.paymentService.saveVerifoneUnSaved(CCTModel).subscribe((res: any) => {
                        if (!res.Success) {
                          this.toastr.warning('Verifone table failed', 'Info', this.toasterConfig);
                          this.loaderIcon = Promise.resolve(false);
                        }
                      });
                      this.initiatedVoidCC = false;
                      this.loaderIcon = Promise.resolve(false);
                    }
                    let toastrMsg = "";
                    let cancelOrRefundResStatus = false;
                    if (cancelOrRefundRes.Status == "canceled") {
                      toastrMsg = "Payment Intent has been cancelled!";
                      cancelOrRefundResStatus = true;
                    }
                    if (cancelOrRefundRes.Status == "succeeded" || cancelOrRefundRes.Status == "pending") {
                      toastrMsg = "Credit card payment reversed successfully";
                      cancelOrRefundResStatus = true;
                    }
                    var obj = {
                      VerifoneId: this.verifoneRecordId,
                      PaymentSuccess: cancelOrRefundResStatus,
                      OrderId: orderId,
                      CardNumber: `XXXXXXXXXXX${CharDetailres.CreditCardNumber}`
                    }
                    this.toastr.info(toastrMsg, 'Info', this.toasterConfig);
                    this.PaymentResponse.emit(obj);
                    this.loaderIcon = Promise.resolve(false);
                  }, err => {
                    const errprResponse = this.handelStripeError(err);
                    CharDetailres.ResponseCode = errprResponse.ResponseCode;
                    CharDetailres.Reason = errprResponse.Reason;
                    CharDetailres['errprResponse'] = JSON.stringify(err);
                    this.saveStripeCCTransactionFail(CharDetailres, "", orderId, EPaymentTransactionType.Reversal_Refund);
                  });
                }
                else{
                  this.saveStripeCCTransactionFail(CharDetailres, "", orderId, EPaymentTransactionType.Reversal_Refund);
                }
              }, err => {
                if (err?.error?.error) {
                  this.toastr.error(err.error.error, 'Failure', this.toasterConfig);
                } else {
                  this.toastr.error('Failed to Get Charges Details By IntentId ', 'Failure', this.toasterConfig);
                }
                this.loaderIcon = Promise.resolve(false);
              });
            //}
          }
        }
      });
    });
  }

  capturePaymentIntent(MarketId, paymentIntentId, orderId) {
    this.paymentService.CapturePaymentIntent(MarketId, paymentIntentId).subscribe((response: any) => {
      if (response.Status == "succeeded") {
        //this.paymentService.updateCreditCardPaymentReason(orderId, response.Status).subscribe(() => { })
      }
    }, () => {
    });
  }
  
  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  unSubscribeSignalRSubscribe() {
    if (this.stripeResponseSubscription != null) {
      this.stripeResponseSubscription.unsubscribe();
      this.stripeResponseSubscription = null;
    }
  }

  handelStripeError(err) {
    let errorMessage = err?.error?.details ? err.error.details : err?.error?.error ? err.error.error : err?.error?.detail ? err.error.detail : "Declined!";
    const obj = {
      Reason: errorMessage,
      ResponseCode: err?.error?.status ?? '',
      Success: false
    }
    return obj;
  }

  saveStripeCCTransactionFail(stripFailedResponse, paymentTrnsId, orderId, paymentMode) {
    var Reason = "";
    var ResponseCode = "";
    var ReceiptResponse = "";

    if (stripFailedResponse.Reason !== "") {
      Reason = stripFailedResponse.Reason;
      ResponseCode = stripFailedResponse.ResponseCode;
      ReceiptResponse = stripFailedResponse.errprResponse;
    }
    else {
      let errprResponse = this.handelStripeError(stripFailedResponse);
      Reason = errprResponse.Reason;
      ResponseCode = errprResponse.ResponseCode;
      ReceiptResponse = JSON.stringify(stripFailedResponse);
    }
    this.paymentSuccessFul = false;
    this.paymentProcessing = false;
    this.payStatus = 'Failed';
    this.paymentTable.find(o => o.payId == this.currentPayId).payFailed = true;
    stripFailedResponse['PaymentModeId'] = paymentMode;
    let CCTModel;
    const tempCCModel = {
      VerifoneId: this.verifoneRecordId,
      CreditCardNumber: stripFailedResponse.CreditCardNumber,
      CardType: stripFailedResponse.CardType,
      ResponseCode: ResponseCode ?? '',
      ResponseMessage: Reason ?? '',
      ReceiptResponse: ReceiptResponse,
      Card: this.keyedInTransaction ? "Credit Card" : "",
      TransactionDateTime: new Date(),
      OrderId: orderId,
      VendorId: this.VendorId,
      ProcessStatus: "Failed",
      PaymentTransactionTypeId: stripFailedResponse.PaymentIntentId,
      ApprovalCode: stripFailedResponse.ChargeId,
      CreditCardType: stripFailedResponse.CardBrand
    };
    CCTModel = Object.assign(tempCCModel);
    this.paymentService.saveVerifoneUnSaved(CCTModel).subscribe((res: any) => {
    });

    this.loaderIcon = Promise.resolve(false);
    Swal.fire({
      title: $localize`Payment Failed!`,
      html: `<h5>Uh-oh! We Were Unable To Process Your Payment</h5>
                <p>`+ stripFailedResponse.Reason + `</p>`,
      icon: "error", confirmButtonText: $localize`Ok`,
    }).then(result => {
      if (result.value) { this.gotoPaymentSuccess(0); }
    });
  }
}
